export default "__VITE_ASSET__BHlJWiPE__"